// Module
var code = "<div class=\"info-card\"><div class=\"info-detail-wrapper\"><div layout=\"row\" ng-repeat=\"(key, value) in $ctrl.displayInfo track by $index\"><span ng-if=\"value !== ''\" class=\"data-type\">{{key}}:</span> <span ng-if=\"value !== ''\" class=\"data-value\" ng-bind-html=\"value\"></span></div></div></div>";
// Exports
module.exports = code;